import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import useOptimizelyDecisions from 'lib/hooks/useOptimizelyDecisions';
import { titleStyles } from './styles';

interface TitleProps {
  isSubmitted: boolean;
  className?: string;
}

export default function Title({ isSubmitted, className = '' }: TitleProps): JSX.Element {
  const { t } = useTranslation();
  const { testLeadCTA } = useOptimizelyDecisions();
  const translationVariant = testLeadCTA ? 'leadForm.requestInfo' : 'leadForm.checkAvailability';
  return (
    <div
      className={classNames('title', className, {
        contacted: isSubmitted,
      })}
    >
      <div className="text-container">
        <h3 className="text">
          {isSubmitted ? t('leadForm.sellerContacted') : t(translationVariant)}
        </h3>
        {isSubmitted && <div className="sub-text">{t('leadForm.contactedSubtext')}</div>}
      </div>
      <div className={isSubmitted ? 'contacted-check' : 'plane'} />
      <style jsx>{`
        .title {
          justify-content: space-between;
        }
      `}</style>
      <style jsx>{titleStyles}</style>
    </div>
  );
}
